<template>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition"
            v-model="value"
    >
        <v-card v-if="stack.api.getLoaded">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('title.editStack') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save()">
                        <v-icon left>save</v-icon>
                        {{ $t('nav.save') }}
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                                :label="$t('field.name')"
                                v-model="stack.name"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-textarea
                                :label="$t('field.description')"
                                v-model="stack.description"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <public-input v-model="stack.public"></public-input>
                </v-row>
                <div>
                    {{ message }}
                </div>
            </v-container>
        </v-card>
        <v-container v-else>
            <h2 class="text-center">
                {{ $t('nav.loading') }}
            </h2>
        </v-container>
    </v-dialog>
</template>

<script>
    import PublicInput from "@/components/widgets/PublicInput";
    import {Stack} from "@/models/Stack";

    export default {
        name: "StackEdit",
        components: {PublicInput},
        data: function () {
            return {
                dialog: false,
                message: '',
                stack: new Stack(),
            }
        },
        props: {
            pk: {
                required: true,
                type: Number,
            },
            value: {
                required: true,
                type: Boolean,
            }
        },
        watch: {
            value: function () {
                if (this.value) {
                    this.stack.api.fetch(this.pk);
                }
            },
        },
        methods: {
            save () {
                let that = this;
                this.stack.api.save().then(function () {
                    that.close();
                }).catch(error => {
                    that.message = error;
                })
            },
            cancel () {
                this.message = 'Cancel clicked.';
            },
            close () {
              // this.value = false;
              this.$emit('closed')
            },
        },
    }
</script>

<style scoped>
</style>
